// // officialsData

// export const incomingOfficials = [
//   {
//     name: "Asst. Prof. Dukuly, Alaju S.M",
//     position: "President-Elect",
//     image: "/images/dukuly-alaju.jpg",
//   },
//   {
//     name: "Kiazolu, J. Boimah",
//     position: "VP-Elect, Administration",
//     image: "/images/kiazolu-boimah.jpg",
//   },
//   {
//     name: "Yanquoi, B. Orando",
//     position: "VP-Elect, International Affairs",
//     image: "/images/yanquoi-orando.jpg",
//   },
//   {
//     name: "Patten, Eric T.S",
//     position: "Secretary General-Elect",
//     image: "/images/patten-eric.jpg",
//   },
//   {
//     name: "Peters, Smith",
//     position: "Asst. Secretary General-Elect",
//     image: "/images/peters-smith.jpg",
//   },
//   {
//     name: "Saydee, Geetah S.",
//     position: "Treasurer-Elect",
//     image: "/images/saydee-geetah.jpg",
//   },
//   {
//     name: "Rev. Ba rolle-Forkeyoh, S.O.",
//     position: "Chaplain-Elect",
//     image: "/images/ba-rolle-forkeyoh.jpg",
//   }
// ];

// officialsData

export const incomingOfficials = [
  {
    name: "Asst. Prof. Dukuly, Alaju S.M.",
    position: "President-Elect",
    image: "/images/dukuly-alaju.jpeg",
  },
  {
    name: "Kiazolu, J. Boimah",
    position: "VP-Elect, Administration",
    image: "/images/kiazolu-boimah.jpeg",
  },
  {
    name: "Yanquoi, B. Orando",
    position: "VP-Elect, International Affairs",
    image: "/images/yanquoi-orando.jpeg",
  },
  {
    name: "Patten, Eric T.S.",
    position: "Secretary General-Elect",
    image: "/images/patten-eric.jpeg",
  },
  {
    name: "Peters, Smith",
    position: "Asst. Secretary General-Elect",
    image: "/images/peters-smith.jpeg",
  },
  {
    name: "Saydee, Geetah S.",
    position: "Treasurer-Elect",
    image: "/images/saydee-geetah.jpeg",
  },
  {
    name: "Rev. Barrolle-Forkeyoh, S.O.",
    position: "Chaplain-Elect",
    image: "/images/ba-rolle-forkeyoh.jpeg",
  },
];